export default "__VITE_ASSET__C3a3oxbE__"